import React, { useContext, useEffect, useState } from 'react'
import { strCol, numCol } from '@integec/grid-tools/lib/cols'
import { getApiTargetInfo } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import {
  getMisoVerificationTestDefault,
  updateMisoVerificationTestDefault,
  deleteMisoVerificationTestDefault,
  getUnitTypeInfo,
  getFuelCodeInfo,
} from 'api/pgads.js'
import { Button, Select, InputNumber } from 'antd'
import R from 'ramda'
import CommonScreen from './CommonScreen'
import { Label } from 'core/screen-util'
import { ErrorContext } from 'context'

const MisoTestDefault = ({ apiTargetInfo }) => {
  const title = 'Verification Test CLASS XEFORD'
  const [insertEvent, setInsertEvent] = useState(false)
  const { setError } = useContext(ErrorContext)
  const [unitTypeList, setUnitTypeList] = useState([])
  const [fuelTypeList, setFuelTypeList] = useState([])

  useEffect(
    _ => {
      getUnitTypeInfo(apiTargetInfo).fork(setError, setUnitTypeList)
      getFuelCodeInfo(apiTargetInfo).fork(setError, setFuelTypeList)
    },
    [apiTargetInfo, setError]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        width: '100%',
        overflowX: 'auto',
        display: 'grid',
        gap: '5px',
        gridTemplateColumns:
          '100px 150px 100px 150px 120px 100px 150px 100px 100px 120px',
      }}
    >
      <Label>Unit Type :</Label>
      <Select
        value={insertData.unitType}
        onChange={sel => setInsertData({ ...insertData, unitType: sel })}
        style={{ width: '100%' }}
      >
        {R.sortBy(r => r.description)(unitTypeList).map(u => (
          <Select.Option value={u.unitCode} key={u.unitCode}>
            {u.unitCode}-{u.description}
          </Select.Option>
        ))}
      </Select>
      <Label>Primary Fuel : </Label>
      <Select
        value={insertData.primaryFuel}
        onChange={sel => setInsertData({ ...insertData, primaryFuel: sel })}
        style={{ width: '100%' }}
      >
        {R.sortBy(r => r.description)(fuelTypeList).map(u => (
          <Select.Option value={u.code} key={u.code}>
            {u.code}-{u.description}
          </Select.Option>
        ))}
        <Select.Option value="XX" key="XX">
          XX
        </Select.Option>
      </Select>

      <Label>Class Eford : </Label>
      <InputNumber
        value={insertData.classEford}
        onChange={val => setInsertData({ ...insertData, classEford: val })}
      />
      <Label>Class Eford Summer : </Label>
      <InputNumber
        value={insertData.classEfordSummer}
        onChange={val =>
          setInsertData({ ...insertData, classEfordSummer: val })
        }
      />
      <Label>Class Eford Fall : </Label>
      <InputNumber
        value={insertData.classEfordFall}
        onChange={val => setInsertData({ ...insertData, classEfordFall: val })}
      />
      <Label>Min MW : </Label>
      <InputNumber
        value={insertData.minMw}
        onChange={val => setInsertData({ ...insertData, minMw: val })}
      />
      <Label>Max MW : </Label>
      <InputNumber
        value={insertData.maxMw}
        onChange={val => setInsertData({ ...insertData, maxMw: val })}
      />
      <Label>Class Eford Winter : </Label>
      <InputNumber
        value={insertData.classEfordWinter}
        onChange={val =>
          setInsertData({ ...insertData, classEfordWinter: val })
        }
      />
      <Label>Class Eford Spring : </Label>
      <InputNumber
        value={insertData.classEfordSpring}
        onChange={val =>
          setInsertData({ ...insertData, classEfordSpring: val })
        }
      />

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto auto',
          gap: '5px',
          gridColumnEnd: 'span 2',
        }}
      >
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  )
  return (
    <CommonScreen
      title={title}
      header={MisoTestDefaultClassHeaders}
      saveTask={updateMisoVerificationTestDefault}
      retrieveTask={getMisoVerificationTestDefault}
      deleteTask={deleteMisoVerificationTestDefault}
      altBy={d => d.unitType}
      autoRetrieve
      sortOptions={MisoTestDefaultClassHeaders}
      widthOffset={50}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(MisoTestDefault)

const MisoTestDefaultClassHeaders = [
  strCol({
    ident: 'unitType',
    display: 'Unit Type',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'primaryFuel',
    display: 'Primary Fuel',
    isFiltered: true,
    sortOrder: 'asc',
    isKey: true,
  }),
  numCol({ ident: 'minMw', display: 'Min MW', isFiltered: true, isKey: true }),
  numCol({ ident: 'maxMw', display: 'Max MW', isFiltered: true, isKey: true }),
  numCol({
    ident: 'classEford',
    display: 'Class Eford',
    isFiltered: true,
    isKey: false,
    width: 150,
  }),
  numCol({
    ident: 'classEfordSummer',
    display: 'Class Eford Summer',
    isFiltered: true,
    width: 150,
    isKey: true,
  }),
  numCol({
    ident: 'classEfordFall',
    display: 'Class Eford Fall',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'classEfordWinter',
    display: 'Class Eford Winter',
    isFiltered: true,
    width: 150,
  }),
  numCol({
    ident: 'classEfordSpring',
    display: 'Class Eford Spring',
    isFiltered: true,
    width: 150,
  }),

  modifierCol,
  modifiedDateCol,
]
